// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2364":"5f3ec533","8509":"5f3ec533","9532":"5f3ec533","9984":"82490f4f"}[chunkId] + ".css";
};